
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomumbaiurbania() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Urbania On Rent',
        heading: 'Amruta Travels: Pune to Mumbai Urbania On Rent',
        headingDescription: 'Amruta Travels offers Pune to Mumbai Urbania on Rent, delivering a premium and comfortable travel experience for all your intercity travel needs. Whether you are traveling for business, leisure, family events, or airport transfers, our Force Urbania vans ensure a smooth, safe, and luxurious journey between Pune and Mumbai. Ideal for small and medium groups, this service combines comfort, style, and reliability.',


        top: 'Top Places to Visit in Outstation Mumbai with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],

 "services": [
    {
      "name": "Pune to Mumbai Urbania on Rent Near Me",
      "description": "Amruta Travels offers reliable Force Urbania rentals from Pune to Mumbai. Whether you need a 17-seater or a larger vehicle, our well-maintained Urbania vans ensure a comfortable, air-conditioned journey for your group to Mumbai. Book now for hassle-free travel!"
    },
    {
      "name": "Force Urbania 17 Seater for Rent",
      "description": "Rent a Force Urbania 17-seater for your travel needs from Amruta Travels. With comfortable seating, air conditioning, and ample space, our Urbania vehicles are ideal for small group travel to Mumbai and other destinations."
    },
    {
      "name": "Pune to Mumbai Darshan Urbania on Rent",
      "description": "Travel in comfort for your Mumbai Darshan with a Force Urbania from Amruta Travels. Our Urbania rentals provide a luxurious experience with AC, spacious seating, and an experienced driver for a memorable trip to Mumbai’s famous landmarks."
    },
    {
      "name": "Pune to Mumbai Airport Urbania On Rent",
      "description": "Amruta Travels offers Force Urbania rentals for your trip from Pune to Mumbai Airport. Whether you are catching a flight or picking up someone, our 17-seater Urbania vehicles ensure a smooth and comfortable journey with professional drivers."
    },
    {
      "name": "Force Urbania 17 Seater for Rent from Pune to Navi Mumbai",
      "description": "Book a 17-seater Force Urbania for your travel from Pune to Navi Mumbai. Perfect for group trips, our Urbania vans come with air-conditioning, spacious interiors, and experienced drivers to make your journey to Navi Mumbai comfortable."
    },
    {
      "name": "Pune to Santacruz Airport Urbania On Rent",
      "description": "Travel from Pune to Santacruz Airport in style with Amruta Travels. Our Force Urbania rentals offer a luxurious, comfortable ride, with 17-seater capacity, AC interiors, and timely arrivals at Santacruz Airport."
    },
    {
      "name": "Pune to Bandra Kurla Complex Urbania on Rent",
      "description": "Book a Force Urbania from Amruta Travels for your travel from Pune to Bandra Kurla Complex (BKC). Ideal for corporate outings or group visits, our Urbania vehicles ensure a smooth ride with spacious interiors and air conditioning."
    },
    {
      "name": "Pune to Andheri Urbania On Rent",
      "description": "Travel from Pune to Andheri in comfort with Amruta Travels' Urbania rentals. Our Force Urbania 17-seaters provide luxurious interiors, AC comfort, and safe, reliable transport for a pleasant journey to Andheri."
    },
    {
      "name": "Pimpri Chinchwad to Mumbai Urbania On Rent",
      "description": "Travel from Pimpri Chinchwad to Mumbai with ease by renting a Force Urbania from Amruta Travels. Whether you're heading for business or leisure, our Urbania vehicles are the perfect choice for a comfortable, air-conditioned journey."
    },
    {
      "name": "Pune to Navi Mumbai Urbania On Rent",
      "description": "Book a Force Urbania rental for a smooth trip from Pune to Navi Mumbai with Amruta Travels. Our 17-seater vehicles provide ample space, AC comfort, and a professional driver for an enjoyable journey."
    },
    {
      "name": "Pune to Panvel Urbania on Rent",
      "description": "Need a ride from Pune to Panvel? Rent a Force Urbania from Amruta Travels. Our spacious, air-conditioned Urbania vans are perfect for groups, offering a comfortable and stress-free ride to Panvel."
    },
    {
      "name": "Pune to Alibaug Urbania On Rent",
      "description": "Amruta Travels offers Force Urbania rentals for your trip from Pune to Alibaug. With ample space and AC comfort, our 17-seater vehicles are ideal for a group trip to this beautiful coastal destination."
    },
    {
      "name": "Pune to Imagica Urbania On Rent",
      "description": "Travel to Imagica from Pune with Amruta Travels' Force Urbania rentals. Our Urbania vans are designed for comfort, providing AC interiors and enough space for a group of friends or family heading to the amusement park."
    },
    {
      "name": "Pune to Lonavala Urbania on Rent",
      "description": "Rent a Force Urbania from Amruta Travels for your trip from Pune to Lonavala. Whether it's a day trip or a weekend getaway, our Urbania rentals offer a luxurious ride with air conditioning and ample seating for everyone."
    },
    {
      "name": "Pune to Lonavala Khandala Urbania On Rent",
      "description": "Travel to both Lonavala and Khandala with Amruta Travels' Force Urbania rentals. Our vehicles are perfect for family trips or corporate outings, offering spacious seating, AC, and a comfortable journey through the scenic hills."
    },
    {
      "name": "Pune to Mumbai 2 Days Trip Urbania on Rent",
      "description": "Planning a 2-day trip to Mumbai? Rent a Force Urbania from Amruta Travels. Our Urbania vans are equipped with AC, plush seating, and ample space to ensure your group has a comfortable journey over the course of the trip."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Urbania on Rent Near Me", "Force Urbania 17 Seater for Rent"],
    ["Pune to Mumbai Darshan Urbania on Rent", "Pune to Mumbai Airport Urbania On Rent"],
    ["Force Urbania 17 Seater for Rent from Pune to Navi Mumbai", "Pune to Santacruz Airport Urbania On Rent"],
    ["Pune to Bandra Kurla Complex Urbania on Rent", "Pune to Andheri Urbania On Rent"],
    ["Pimpri Chinchwad to Mumbai Urbania On Rent", "Pune to Navi Mumbai Urbania On Rent"],
    ["Pune to Panvel Urbania on Rent", "Pune to Alibaug Urbania On Rent"],
    ["Pune to Imagica Urbania On Rent", "Pune to Lonavala Urbania on Rent"],
    ["Pune to Lonavala Khandala Urbania On Rent", "Pune to Mumbai 2 Days Trip Urbania on Rent"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Luxurious Urbania Vans for Pune to Mumbai",
    "WhyChoosedescription": "Amruta Travels offers premium Urbania vans on rent for your journey from Pune to Mumbai, ensuring a comfortable, luxurious ride. With spacious interiors, plush seating, and top-notch amenities, our Urbania vans provide an ideal travel experience for both short business trips and long-distance leisure travel."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Travel, Events, and Group Outings",
    "WhyChoosedescription": "Whether you're traveling for business meetings, corporate events, or a group outing, our Urbania vans are perfect for accommodating multiple passengers in comfort. With ample space for luggage and comfortable seating, these vans ensure a smooth and productive journey between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Mumbai Travel",
    "WhyChoosedescription": "We provide competitive, transparent pricing for Urbania van rentals from Pune to Mumbai. Our all-inclusive rates cover fuel, tolls, driver allowances, and taxes—there are no hidden charges, allowing you to plan your trip without any surprises."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers for Your Journey",
    "WhyChoosedescription": "Our experienced drivers are well-versed in the best routes between Pune and Mumbai. They ensure that your journey is smooth, safe, and timely, navigating through the traffic efficiently while offering a high level of customer service and professionalism throughout the ride."
  },
  {
    "WhyChooseheading": "Modern Features for Maximum Comfort on Long Journeys",
    "WhyChoosedescription": "Our Urbania vans are equipped with modern features like air conditioning, plush seating, entertainment systems, and USB charging ports, making your 3-4 hour journey from Pune to Mumbai both relaxing and enjoyable. With spacious interiors and high-end amenities, your group will travel in comfort."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service for Mumbai-bound Travel",
    "WhyChoosedescription": "Timeliness is key when traveling between Pune and Mumbai for business or leisure. Our reliable service ensures that your Urbania van arrives on time for your journey, with well-planned routes to ensure punctual arrivals for meetings, events, or sightseeing in Mumbai."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Flexible Rental Options",
    "WhyChoosedescription": "Booking an Urbania van for your Pune to Mumbai trip is quick and easy with Amruta Travels. Our online booking platform allows you to select your vehicle, schedule your rental, and receive instant confirmation. We offer flexible rental durations to accommodate day trips or multi-day bookings."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Seamless Travel Experience",
    "WhyChoosedescription": "Amruta Travels offers round-the-clock customer support to ensure your Pune to Mumbai journey is as smooth as possible. Our team is available for any last-minute changes, route suggestions, or any inquiries you may have, ensuring a hassle-free travel experience."
  }
]





















    }

const faqData = [
  {
    question: 'Can I rent a Force Urbania for a trip from Pune to Mumbai with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Force Urbania rentals for trips from Pune to Mumbai. Our Urbania minibuses provide a comfortable and premium travel experience for group journeys between these two cities.',
  },
  {
    question: 'What seating capacities are available for Force Urbania rentals from Pune to Mumbai?',
    answer: 'We offer Force Urbania minibuses with seating capacities of 13 and 17 seats, making them ideal for small to medium-sized groups traveling from Pune to Mumbai.',
  },
  {
    question: 'Is a driver included with the Force Urbania rental for Pune to Mumbai?',
    answer: 'Yes, all Force Urbania rentals for Pune to Mumbai include an experienced, professional driver who ensures safe, timely, and smooth travel throughout the journey.',
  },
  {
    question: 'How much does it cost to rent a Force Urbania for a Pune to Mumbai trip?',
    answer: 'The cost of renting a Force Urbania depends on the seating capacity, trip duration, and distance. Typically, rates start from ₹35 per km for a 13-seater and ₹38 per km for a 17-seater. Please contact us for a customized quote for your specific trip.',
  },
  {
    question: 'How long does it take to travel from Pune to Mumbai in a Force Urbania?',
    answer: 'The travel time from Pune to Mumbai is typically around 3 to 4 hours, depending on traffic and route conditions. The Force Urbania offers a comfortable and relaxing ride during the journey.',
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained for the Pune to Mumbai trip?',
    answer: 'Yes, all our Force Urbania vehicles are thoroughly maintained and sanitized before every trip. We ensure that the vehicle is in perfect condition for a safe and comfortable journey.',
  },
  {
    question: 'Can I book a Force Urbania online for a Pune to Mumbai trip?',
    answer: 'Yes, you can easily book a Force Urbania for your Pune to Mumbai trip through our website or by contacting our team. We will assist with the booking process and ensure everything is set for your journey.',
  },
  {
    question: 'Is the Force Urbania a good option for a business or corporate trip from Pune to Mumbai?',
    answer: 'Definitely! The Force Urbania is a great choice for corporate trips between Pune and Mumbai, offering luxury, comfort, and ample space for your team or clients. It is also ideal for group tours and special events.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kunal Patil',
    role: 'Business Executive, Pune',
    text: 'We rented a 17-seater Force Urbania for a corporate trip from Pune to Mumbai. The vehicle was perfect—comfortable, clean, and well-equipped. The driver was professional and made our trip smooth and enjoyable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Shweta Kulkarni',
    role: 'Event Planner, Pune',
    text: 'I booked a Force Urbania for a client group traveling from Pune to Mumbai. The bus was spacious and well-maintained. The team was very pleased with the comfort and service provided. Highly recommend Amruta Travels!',
    rating: 5,
  },
];












































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania On Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-mumbai-urbania-on-rent.jpg", // Update with actual image URL
  "description": "Rent a luxury 17-seater Force Urbania for your trip from Pune to Mumbai. Ideal for group tours, airport transfers, or a 2-day trip to popular destinations like Santacruz, Bandra, Andheri, Lonavala, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500", // Adjust price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-mumbai-urbania-on-rent"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Mumbai Urbania On Rent | Luxury Urbania Rental | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury 17-seater Urbania for trips from Pune to Mumbai. Book now for airport transfers, corporate events, and sightseeing in Santacruz, Andheri, Bandra, Navi Mumbai, and more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiurbania;